module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Picture-0d9c529c4f2796f72687b8dcad1fb657.svg";